import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { blotterPanelItemReset } from 'state/blotters/blotterPanel/blotterPanel.action';
import { getBlotterPanelActions, getBlotterPanelTabs } from 'state/blotters/blotterPanel/blotterPanel.selector';
import { emailServiceModalOpened } from 'state/emailService/emailService.actions';
import { addToOrdersBasket } from 'state/orders-basket/actions';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

import type {
  BlotterPanelHeaderDispatchProps,
  BlotterPanelHeaderOwnProps,
  BlotterPanelHeaderStateProps,
} from './BlotterPanelHeader';
import { BlotterPanelHeaderComponent } from './BlotterPanelHeader';

export const mapStateToProps = (state: AppState): BlotterPanelHeaderStateProps => ({
  tabs: getBlotterPanelTabs(state),
  actions: getBlotterPanelActions(state),
});

export const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  { blotterItem }: BlotterPanelHeaderOwnProps,
): BlotterPanelHeaderDispatchProps => ({
  onClosed: () => {
    dispatch(blotterPanelItemReset());
  },
  onAddToNewOrdersBasket: (tabName: string) => {
    dispatch(
      addToOrdersBasket(
        blotterItem.quoteId,
        blotterItem.wrapper,
        blotterItem.productType,
        blotterItem.productSubType,
        tabName,
        blotterItem.processingChain,
        blotterItem.pricerRfqId,
        blotterItem.productId,
      ),
    );
  },
  onSendEmailClicked: () => {
    dispatch(emailServiceModalOpened());
    logAnalytics.trackEvent('Email service', 'Open email service modal');
  },
  onMissedDealFeedbackTabSelected: () => {
    logAnalytics.trackEvent('Blotter My Quotes', 'Select Missed Deal Feedback tab');
  },
});

export const BlotterPanelHeader = connect(mapStateToProps, mapDispatchToProps)(BlotterPanelHeaderComponent);
